import { appUrl } from "../../../constants/url-constants";

export const getDlsCompatibleList = (list = []) => {
    return (list || []).map((item) => {
        return {
            label: item.state,
            isHyperLink: true,
            url: `${appUrl()}/rto-vehicle-registration-details-${item.url}/`
        };
    });
};
